module.exports = __webpack_public_path__ + "static/media/wolfHunt.c2d1056c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wolfHunt.jpg
// module id = 3270
// module chunks = 0